import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import ObligationList from '../../components/obligation/ObligationList/ObligationList';
import { usePermissions } from '../../hooks/usePermissions';
import { Permission } from '../../types/user';

/**
 * Material Obligations Page
 * 
 * Displays list of obligations using the ObligationList component
 * Provides button to create new obligations (role-based)
 */
export default function MaterialObligationsPage() {
  const { hasPermission } = usePermissions();
  const canCreate = hasPermission(Permission.OBLIGATION_CREATE);

  return (
    <Box>
      {/* Page header */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4">
          Compliance Obligations
        </Typography>
        {canCreate && (
          <Button
            id="create-obligation-button"
            data-testid="create-obligation-button"
            variant="contained"
            startIcon={<AddIcon />}
            component={Link}
            to="/obligations/create"
          >
            New Obligation
          </Button>
        )}
      </Box>
      
      {/* Obligation list */}
      <ObligationList />
    </Box>
  );
}
